function easeInOutSin(time: number): number {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

export function animate(
    property: 'scrollLeft' | 'scrollTop',
    element: HTMLElement,
    to: number,
    options: { ease?: (time: number) => number; duration?: number },
    callback?: (error: Error | null) => void
) {
    const {
        ease = easeInOutSin,
        duration = 300, // standard
    } = options;

    let start: number | null = null;
    const from = element[property];
    let cancelled = false;

    const cancel = () => {
        cancelled = true;
    };

    const step = (timestamp: number) => {
        if (cancelled) {
            if (callback) {
                callback(new Error('Animation cancelled'));
            }
            return;
        }

        if (start === null) {
            start = timestamp;
        }
        const time = Math.min(1, (timestamp - start) / duration);

        // eslint-disable-next-line no-param-reassign
        element[property] = ease(time) * (to - from) + from;

        if (time >= 1) {
            requestAnimationFrame(() => {
                if (callback) {
                    callback(null);
                }
            });
            return;
        }

        requestAnimationFrame(step);
    };

    if (from === to) {
        if (callback) {
            callback(new Error('Element already at target position'));
        }
        return cancel;
    }

    requestAnimationFrame(step);
    return cancel;
}
